export default "__VITE_ASSET__B8Nho03q__"